import { FC, SVGAttributes } from 'react';

const KakaoCircle: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="32" cy="32" r="32" fill="#FFE134" />
      <path
        d="M31.9992 18.6665C23.1635 18.6665 16 24.3165 16 31.287C16 35.8241 19.0341 39.8005 23.5895 42.0247C23.2541 43.2715 22.3785 46.5434 22.2024 47.2412C21.9861 48.1098 22.5211 48.0981 22.8733 47.8638C23.1484 47.6814 27.2576 44.8932 29.0305 43.6916C30.0139 43.8367 31.0067 43.9094 32.0008 43.9091C40.8365 43.9091 48 38.2575 48 31.2887C48 24.3199 40.8365 18.6682 32.0008 18.6682"
        fill="#391B1B"
      />
    </svg>
  );
};

export default KakaoCircle;
